var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAvatarFilledAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6a3.75 3.75 0 100 7.5A3.75 3.75 0 0012 6z",
    fill: "#45464F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5A10.5 10.5 0 1022.5 12 10.512 10.512 0 0012 1.5zm5.994 17.194A3.751 3.751 0 0014.25 15h-4.5a3.751 3.751 0 00-3.744 3.694 9 9 0 1111.988 0z",
    fill: "#45464F"
  })));
}
export default SvgUserAvatarFilledAlt;